import { useEffect } from 'react';
import { useParams, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LanguageWrapper = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  console.log("LanguageWrapper rendered, pathname:", location.pathname);

  useEffect(() => {
    const supportedLangs = ['sr', 'en'];
    
    // Ako je URL npr. pccentar.rs/en, postavi jezik na engleski
    if (lang && supportedLangs.includes(lang)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    } 
    // Ako nema prefiksa (pccentar.rs/), a jezik u sistemu je engleski, 
    // prebaci ga na srpski kao default za root URL
    else if (!lang && i18n.language !== 'sr') {
      i18n.changeLanguage('sr');
    }
  }, [lang, i18n]);

  return <Outlet />;
};

export default LanguageWrapper;